<div class="image-edit">
  <div class="edit-canvas">
    <image-cropper
      #imageCropper
      alignImage="center"
      [disabled]="isProcessing()"
      [imageFile]="originalFile()"
      [maintainAspectRatio]="isAspectRatioLocked()"
      [aspectRatio]="aspectRatio() ?? 1"
      [format]="outputFormat()"
      [resizeToWidth]="resizeToSize()?.width"
      [resizeToHeight]="resizeToSize()?.height"
      [onlyScaleDown]="true"
      [allowMoveImage]="false"
      [imageQuality]="80"
      [canvasRotation]="canvasRotation()"
      [(cropper)]="cropperPosition"
      [style.display]="showCropper() ? null : 'none'"
      (imageLoaded)="onImageLoaded($event)"
      (cropperReady)="onCropperReady()"
      (loadImageFailed)="onImageLoadFailed()"
      (imageCropped)="onImageCropped($event)"
    />
  </div>
  <div class="edit-panel">
    <div class="left-panel">
      <span>Image Ratio:</span>
      <div class="input-wrapper">
        <input
          type="number"
          min="1"
          class="first bd-text-input tall"
          [disabled]="!canInputRatio()"
          [ngModel]="ratioWidth()"
          (ngModelChange)="onRatioChanged($event, undefined)"
          autocomplete="off"
        />
        <span>W</span>
      </div>
      <span>:</span>
      <div class="input-wrapper">
        <input
          type="number"
          min="1"
          class="bd-text-input tall"
          [disabled]="!canInputRatio()"
          [ngModel]="ratioHeight()"
          (ngModelChange)="onRatioChanged(undefined, $event)"
          autocomplete="off"
        />
        <span>H</span>
      </div>
    </div>
    <div class="right-panel">
      <button
        class="btn btn-default"
        [disabled]="!showCropper() || isProcessing()"
        (click)="onRotateImage(true)"
      >
        <mat-icon svgIcon="icon_reset_16" class="icon-24 scale-x-[-1]" />
      </button>
      <button
        class="btn btn-default"
        [disabled]="!showCropper() || isProcessing()"
        (click)="onRotateImage(false)"
      >
        <mat-icon svgIcon="icon_reset_16" class="icon-24" />
      </button>
    </div>
  </div>
</div>
